import React from 'react';
import {Button, Typography} from '@bonprix/design-system';

export default function LoadMoreButton({loading, hasMore, texts, onLoadMore, currentArticles, hits}) {
    if (!hasMore) return null;

    return (
        <div id="load-more-button" className="flex flex-col justify-center items-center py-8 bg-white min-w-[200px] max-w-[360px]" >

            <div className={'mb-4'}>


                <Typography
                    variant="h5"
                    className="text-center text-clr-primary"
                >
                    {texts?.load_more_button_article_count_label
                        ? texts.load_more_button_article_count_label
                            .replace('{0}', currentArticles)
                            .replace('{1}', hits)
                        : `${currentArticles} von ${hits} Artikeln gesehen`
                    }
                </Typography>
            </div>
            <Button
                variant="primary"
                size="large"
                onClick={onLoadMore}
                disabled={loading}
                className="w-[360px] "
            >
                {loading ? texts?.loading || 'Lädt...' : (texts.load_more_button_label || 'Mehr Artikel laden')}
            </Button>
        </div>
    );
}